// extracted by mini-css-extract-plugin
export default {"input":"Form_input__FTtTw","button":"Form_button__8NOIT"};